import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getDomains } from '../../services'
import { AdminQueryKey } from '@/modules/admin/keys'
import { GetDomainsResponse } from '@/modules/admin/type'

export default function useQueryGetDomains(
	props?: UseBaseQueryOptions<GetDomainsResponse>,
) {
	return useQuery({
		queryKey: [AdminQueryKey.GetDomains],
		queryFn: () => getDomains(),
		...props,
	})
}
